import script from "./CompleteArtistCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompleteArtistCard.vue?vue&type=script&setup=true&lang=js"

import "./CompleteArtistCard.vue?vue&type=style&index=0&id=7aa520c1&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7aa520c1"]])

export default __exports__